import { LuLayers, LuPackage } from "react-icons/lu";
import { HStack, Icon, Text } from "@chakra-ui/react";

import { RoundedBadge } from ".";

import { DEFAULT_UNIT_OF_MEASURE } from "@entities/item";

type Variant = "default" | "muted" | "error";

const primaryPalette: Record<Variant, string> = {
  default: "blue",
  muted: "gray",
  error: "red",
};

const secondaryPalette: Record<Variant, string | undefined> = {
  default: undefined,
  muted: "gray",
  error: "red",
};

interface Props {
  quantity: number;
  unitOfOrder: string;
  unitsInUOO: number;
  unitOfMeasure?: string;
  variant?: Variant;
}

export const UnitBreakdown: React.FC<Props> = ({
  quantity,
  unitOfOrder,
  unitsInUOO,
  unitOfMeasure,
  variant = "default",
}) => {
  if (!quantity) return null;

  const uom = unitOfMeasure || DEFAULT_UNIT_OF_MEASURE;
  const totalUnits = quantity * unitsInUOO;

  return (
    <HStack gap={1} mt={0.5} w="full" justifyContent="flex-end">
      <RoundedBadge colorPalette={primaryPalette[variant]} textTransform="none">
        <HStack gap={1} alignItems="center" px={1} py={0.5}>
          <Icon as={LuPackage} boxSize={4} />
          <span>
            {quantity} {unitOfOrder}
          </span>
        </HStack>
      </RoundedBadge>
      <Text fontSize="xs" color="fg.muted">
        /
      </Text>
      <RoundedBadge
        colorPalette={secondaryPalette[variant]}
        textTransform="none"
      >
        <HStack gap={1} alignItems="center" px={1} py={0.5}>
          <Icon as={LuLayers} boxSize={4} />
          <span>
            {Intl.NumberFormat("en-US").format(totalUnits)} {uom}
          </span>
        </HStack>
      </RoundedBadge>
    </HStack>
  );
};
